import { FC, memo, useCallback } from 'react'

import ListingSectionTransport from '../../../transports/common/listing-section-transport'
import GridCard from '../../common/grid-card'
import {
    CtaButtonText,
    CtaContainer,
    Section,
    StyledGhostButton,
    Subtitle,
    Title,
    TitleContainer,
} from '../common/styles'
import { useTranslation } from '../../../hooks/locale'
import { BreadcrumbListTransport } from '../../../models/common/breadcrumb-model'
import { Offer } from '../../../models/common/offers-model'
import { SuitablesModel } from '../../../models/common/suitables-model'
import { useResponsiveCards } from '../../../hooks/responsive'
import { SliderContainer } from '../../common/listing-card-section/styles'
import { cardEventCategories, pageTypeEventCategories } from '../../../services/analytics-service/categories'
import { EmblaCarousel } from '../../common/embla-carousel'

interface Props {
    listingSection: ListingSectionTransport
    url: string
    defaultHeading: string
    defaultSubheading?: string
    breadcrumbModel: BreadcrumbListTransport
    offerModel: Offer
    suitablesModel: SuitablesModel
}

const TopOffersSection: FC<Props> = ({
    listingSection,
    url,
    defaultHeading,
    defaultSubheading,
    breadcrumbModel,
    offerModel,
    suitablesModel,
}) => {
    const { t } = useTranslation()

    const { objects, cta } = listingSection

    const heading = listingSection.heading || defaultHeading
    const subheading = listingSection.subheading || defaultSubheading

    const visibleSlides = useResponsiveCards()
    const slidesToScroll = Math.floor(visibleSlides)

    const _handleCTAButtonClick = useCallback(() => {
        document.location.href = cta?.url || url
    }, [url, cta?.url])

    return (
        <Section id="top-offers">
            <TitleContainer>
                <Title>{heading}</Title>
                {!!subheading && <Subtitle>{subheading}</Subtitle>}
            </TitleContainer>
            <SliderContainer>
                <EmblaCarousel
                    slides={objects.map((object, index) => (
                        <GridCard
                            key={object.id}
                            index={index}
                            listingObject={object}
                            requestUrl={url}
                            pageName={pageTypeEventCategories.HOME}
                            sectionName={cardEventCategories.sections.TOP_OFFERS}
                            breadcrumbModel={breadcrumbModel}
                            offerModel={offerModel}
                            suitablesModel={suitablesModel}
                            showFeatures={false}
                        />
                    ))}
                    visibleSlides={visibleSlides}
                    slidesToScroll={slidesToScroll}
                    showNav
                    navVariant="top-right"
                    navPosition={{ desktopTop: '-5.15rem', desktopRight: '0', wideTop: '-5.15rem', wideRight: '0' }}
                />
            </SliderContainer>
            {!!cta?.url && (
                <CtaContainer>
                    <StyledGhostButton onClick={_handleCTAButtonClick} borderRadius="1rem">
                        <CtaButtonText>{t('seeAll')}</CtaButtonText>
                    </StyledGhostButton>
                </CtaContainer>
            )}
        </Section>
    )
}

export default memo(TopOffersSection)
